import { createRouter } from "@tanstack/react-router";
import { routerWithQueryClient } from "@tanstack/react-router-with-query";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { routeTree } from "@/routeTree.gen";
import { convexQueryClient, queryClient } from "./query-client";

export const router = routerWithQueryClient(
	createRouter({
		routeTree,
		defaultPreload: "intent",
		defaultPreloadStaleTime: 30_000,
		defaultPendingComponent: () => <LoadingScreen isLoading />,
		defaultPendingMs: 200,
		scrollRestoration: true,
		context: { queryClient, convexQueryClient },
	}),
	queryClient,
);

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
